import { ErrorBox } from '#app/shared/components/Errors/ErrorBox'
import { Box } from '@mui/material'

export const AppFatalPage: React.FC = () => {
  return (
    <Box data-testid="application-fatal">
      <ErrorBox />
    </Box>
  )
}
